import React from 'react';
import './FaqPanel.css';

const FaqPanel = ({ isOpen, title, items, onClose }) => {
  return (
    <div className={`faq-panel ${isOpen ? 'faq-open' : ''}`}>
      <div className="faq-panel-header">
        <span className="faq-panel-title">{title}</span>
        <button className="faq-close-btn" onClick={onClose}>
          &times;
        </button>
      </div>
      <div className="faq-list">
        {items && items.map((item, index) => (
          <div className="faq-item" key={index}>
            <div className="faq-question">{item.q}</div>
            <div className="faq-answer">{item.a}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqPanel;
